var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McLayoutDefault',{attrs:{"heading":_vm.$t('headings.statusMessage')}},[(!_vm.$perms.isAdministrator())?_c('b-card',{staticClass:"mb-2",attrs:{"title":_vm.$t('permissions.LackingPermissions')}},[_c('p',[_vm._v(_vm._s(_vm.$t('permissions.LackingPermissionsLonger')))])]):_vm._e(),_c('StatusMessageForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }